(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ContractCopyDialogController', ContractCopyDialogController);

    ContractCopyDialogController.$inject = ['$rootScope', '$scope', '$stateParams', 'entity', 'Contract', 'ToastrService', '$uibModalInstance', 'ContractCustomService'];

    function ContractCopyDialogController($rootScope, $scope, $stateParams, entity, Contract, ToastrService, $uibModalInstance, ContractCustomService) {
        var vm = this;

        vm.entity = entity;
        vm.contract = undefined;

        vm.clear = clear;
        vm.save = save;
        vm.loadFullContract = loadFullContract;

        loadFullContract();

        function loadFullContract() {
            Contract.get({id: vm.entity.id}).$promise.then(function (data) {
                vm.contract = data;
            }, function (error) {
                ToastrService.error("Failed to load contract", "Error!");
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save(goToEdit) {
            if (validContractToSave()) {
                vm.isSaving = true;
                vm.contract.id = null;

                Contract.save(vm.contract, function (data) {
                    if (goToEdit) {
                        $rootScope.$emit('handleEmit', {
                            heading: 'Edit ' + data.contractNum,
                            route: data.subCategory === 'PURCHASE' ? 'purchase.edit' : 'sale.edit',
                            id: data.id,
                            param: { id: '' }
                        });
                    }
                    $uibModalInstance.dismiss('ok');
                }, function (error) {
                    if (error.status !== "404") {
                        ToastrService.error("Failed to copy contract", "Error!");
                    }
                    $uibModalInstance.dismiss('ok');
                });
            }
        }

        function validContractToSave() {
            return vm.contract.contractNum &&
                vm.contract.contractNum.length > 0 &&
                vm.contract.quantity &&
                vm.contract.quantity >= 0;
        }
    }
})();
